import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';

import DataGrid from 'components/DataGrid';
import { DataGridColDef, DataGridProps } from 'components/DataGrid/DataGrid';

import DF from 'DisplayFramework';
import {
  getPayFileByCriteria,
  GetPayFileByCriteriaParams,
} from 'services/PaymentServices';
import { useHistory, useLocation } from 'react-router-dom';
import MGListSelect from 'pages/Configuration/Components/MGListSelect';
import ParListSelect from 'components/ParListSelect';
import { DatePicker } from 'antd';
import { dateToString } from 'utils/utils2';
import { toCurrency } from 'utils/utils';
import BankAccountSelect from 'components/ParBankAccountSelect/BankAccountSelect';
export type PayListProps = Pick<DataGridProps<any>, 'rowSelection'> & {
  isModal?: string;
  onSelect?: (item: any) => void;
  hideCIListModal?: () => void;
  hideCol?: boolean;
  hideExtraAction?: boolean;
  paydirection?: string;
};
const PFileList = (props: PayListProps) => {
  const { onSelect } = props;
  const history = useHistory();

  const { rowSelection, paydirection } = props;
  const [currcode, setCurrcode] = useState('');
  const [mgid, setMgid] = useState(Number(localStorage.getItem('mgid')));
  const [searchs, setsearchs] = useState(false);

  const search = useLocation().search;
  const direction =
    new URLSearchParams(search).get('direction') ?? paydirection;

  const [directions, setDirections] = useState(direction);

  const initialSearchParams: GetPayFileByCriteriaParams = {
    createdate: '',
    currcode: '',
    mgbkid: '' as any,
    mgid: Number(localStorage.getItem('mgid')),
    paydirection: direction ?? '',
    paymode: '',
    pfid: '' as any,
    pfstatus: '',
  };

  const [searchParams, setSearchParams] =
    useState<GetPayFileByCriteriaParams>(initialSearchParams);

  const { data, refetch, isFetching } = useQuery(
    ['findPaymentByAnyRefOrStatusOrDate', searchParams],
    () =>
      getPayFileByCriteria(searchParams).then((res) => {
        setsearchs(false);
        return res.list || [];
      }),
    { refetchOnMount: false, enabled: searchs }
  );

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'pfid',
        width: 80,
        filtrable: true,
        render: (value, record) => (
          <a
            onClick={() => {
              onSelect ? onSelect(value) : history.push(`pfiledetail/${value}`);
            }}
          >
            {value}
          </a>
        ),
      },
      {
        dataIndex: 'mgid',
        filtrable: true,
        width: 230,
        filterComponent: (
          <MGListSelect
            onSelect={(e) => {
              setMgid(e);
            }}
          />
        ),
        render: (value, record) => <MGListSelect value={value} disabled />,
      },

      {
        dataIndex: 'currcode',
        filtrable: true,
        width: 120,
        filterComponent: (
          <ParListSelect
            parcode="CURRENCY"
            onSelect={(e) => {
              setCurrcode(e);
            }}
          />
        ),
      },
      {
        dataIndex: 'paydirection',
        filtrable: 'paydirection',
        width: 120,
        filterComponent: (
          <ParListSelect
            parcode="PAYFDIR"
            onSelect={(e) => {
              setDirections(e);
            }}
          />
        ),
      },

      {
        dataIndex: 'mgbkid',
        filtrable: true,
        width: 230,
        filterComponent: (
          <BankAccountSelect
            mgid={mgid}
            direction={directions ?? ''}
            currcode={currcode}
            strict
          />
        ),
        render: (value, record) => record.bankname,
      },
      {
        dataIndex: 'paymodelabel',
        filtrable: 'paymode',
        filterComponent: <ParListSelect parcode="PAYMODAUTO" />,
        width: 150,
      },

      {
        dataIndex: 'creationdate',
        filtrable: true,
        filterComponent: <DatePicker />,
        render: (value, record) =>
          dateToString(record.creationdate).substring(0, 10),
        width: 120,
      },

      {
        dataIndex: 'duedate',
        filterComponent: <DatePicker />,
        width: 120,
      },

      {
        dataIndex: 'pftotallines',
        width: 120,
      },
      {
        dataIndex: 'pftotalamount',
        width: 120,
        render: (val, record) => toCurrency(val, record.currcode),
      },
      {
        dataIndex: 'pfstatuslabel', //pfstatuslabel
        filtrable: 'pfstatus',
        width: 120,
        filterComponent: <ParListSelect parcode="PFSTATUS" />,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParams, refetch, mgid, direction, directions, currcode]
  );

  return (
    <DF.Provider pagcode="pfilelist">
      <DataGrid
        rowKey="payid"
        dataSource={data}
        titleComcode={
          paydirection === 'IN' ? 'paymentFileINlist' : 'paymentFileOUTlist'
        }
        columns={columns}
        hideExtraAction
        onSearch={(value) => {
          setSearchParams(value);
          setsearchs(true);
        }}
        onClear={() => {
          setDirections('');
        }}
        initialSearchValues={initialSearchParams}
        isLoading={isFetching}
        rowSelection={rowSelection}
      />
    </DF.Provider>
  );
};

export default PFileList;
